import { track } from 'cm'

const { lesson_id, keshi_id, is_join, lesson_title } = window.baseInfo
const GetQueryString = (name, url) => {
  var reg = new RegExp(`(^|&?)${name}=([^&]*)(&|$)`)
  var r = (url || window.location.search.substr(1)).match(reg)
  if (r != null) return decodeURI(r[2])
  return null
}

let kcTrackParams = {
  lesson_id: lesson_id,
  lesson_sections_id: keshi_id
}

// 课时播放页
export const onPageViewTrack = () => {
  track.trackPageView('lessonsectionsplay_view', {
    ...kcTrackParams,
    purchase_status: +is_join === 1 ? '已购买' : '未购买'
  })
}

// 课时播放页-查看课程详情
export const onDetailTrack = () => {
  track.trackEvent('lessonsectionsplay_checklesson', {
    ...kcTrackParams,
    lesson_name: lesson_title,
    purchase_status: +is_join === 1 ? '已购买' : '未购买'
  })
}

// 课时播放页-点击购买
export const onBuyTrack = () => {
  track.trackEvent('lessonsectionsplay_buy', {
    ...kcTrackParams,
    lesson_name: lesson_title
  })
}



// WEBPACK FOOTER //
// ./src/pages/lesson/play/track.js